import { Component, OnInit } from '@angular/core';
import { PublicService } from '../public.service';
import { Router, NavigationEnd } from '@angular/router';


@Component({
  selector: 'app-selected-items',
  templateUrl: './selected-items.component.html',
  styleUrls: ['./selected-items.component.scss']
})
export class SelectedItemsComponent implements OnInit {
  cpuCounter = 1;
  riceCounter = 1;
  plasticCounter = 1;
  canCounter = 1;
  bottleCounter = 1;
  paperCounter = 1;
  shoesCounter = 1;
  dryCounter = 1;
  breadCounter = 1;
  ironCounter = 1;
  mesCounter = 1;
  chodanCounter = 1;
  petCounter = 1;
  basketCounter = 1;
  lakCounter = 1;
  alSabokCounter = 1;
  alSanginCounter = 1;

  loading = false;

  money = 0;

  cpuPerKilo = 35000;
  ricePerKilo = 70000;
  plasticPerKilo = 3000;
  canPerKilo = 3800;
  bottlePerKilo = 180;
  paperPerKilo = 1750;
  shoesPerKilo = 12000;
  dryPerKilo = 2200;
  breadPerKilo = 1600;
  ironPerKilo = 5100;
  mesPerKilo = 80000;
  chodanPerKilo = 35000;
  petPerKilo = 2500;
  basketPerKilo = 3000;
  lakPerKilo = 2500;
  alSabokPerKilo = 13000;
  alSanginPerKilo = 15000;

  cpuMaxPrice = 35000;
  riceMaxPrice = 70000;
  plasticMaxPrice = 3000;
  canMaxPrice = 3800;
  bottleMaxPrice = 180;
  paperMaxPrice = 1750;
  shoesMaxPrice = 12000;
  dryMaxPrice = 2200;
  breadMaxPrice = 1600;
  ironMaxPrice = 5100;
  mesMaxPrice = 80000;
  chodanMaxPrice = 35000;
  petMaxPrice = 2500;
  basketMaxPrice = 3000;
  lakMaxPrice = 2500;
  alSabokMaxPrice = 13000;
  alSanginMaxPrice = 15000;

  cpuStatus = "deactive";
  riceStatus = "deactive";
  plasticStatus = "deactive";
  canStatus = "deactive";
  bottleStatus = "deactive";
  paperStatus = "deactive";
  shoesStatus = "deactive";
  dryStatus = "deactive";
  breadStatus = "deactive";
  ironStatus = "deactive";
  mesStatus = "deactive";
  chodanStatus = "deactive";
  petStatus = "deactive";
  basketStatus = "deactive";
  lakStatus = "deactive";
  alSabokStatus = "deactive";
  alSanginStatus = "deactive";

  displayPaper = "displayYes";
  displayShoes = "displayYes";
  displayBottle = "displayYes";
  displayBasket = "displayYes";
  displayCan = "displayYes";
  displayChodan = "displayYes";
  displayPlastic = "displayYes";
  displayRice = "displayYes";
  displayCpu = "displayYes";
  displayIron = "displayYes";
  displayAlSangin = "displayYes";
  displayAlSabok = "displayYes";
  displayPet = "displayYes";
  displayLak = "displayYes";
  displayDry = "displayYes";
  displayMes = "displayYes";
  displayBread = "displayYes";

  constructor(public publicservice: PublicService, public router: Router) {

    // if (publicservice.logedIn == "false" || this.publicservice.logedIn == null) {
    //   this.router.navigate(['login']);
    // }

    this.displayPaper = "displayYes";
    this.displayShoes = "displayYes";
    this.displayBottle = "displayYes";
    this.displayBasket = "displayYes";
    this.displayCan = "displayYes";
    this.displayChodan = "displayYes";
    this.displayPlastic = "displayYes";
    this.displayRice = "displayYes";
    this.displayCpu = "displayYes";
    this.displayIron = "displayYes";
    this.displayAlSangin = "displayYes";
    this.displayAlSabok = "displayYes";
    this.displayPet = "displayYes";
    this.displayLak = "displayYes";
    this.displayDry = "displayYes";
    this.displayMes = "displayYes";
    this.displayBread = "displayYes";

    this.publicservice.location = localStorage.getItem("location")!;

    if (sessionStorage.getItem('plasticStatus') == 'true') {
      this.plasticStatus = "active";
    }
    if (sessionStorage.getItem('breadStatus') == 'true') {
      this.breadStatus = "active";
    }
    if (sessionStorage.getItem('cpuStatus') == 'true') {
      this.cpuStatus = "active";
    }
    if (sessionStorage.getItem('paperStatus') == 'true') {
      this.paperStatus = "active";
    }
    if (sessionStorage.getItem('canStatus') == 'true') {
      this.canStatus = "active";
    }
    if (sessionStorage.getItem('riceStatus') == 'true') {
      this.riceStatus = "active";
    }
    if (sessionStorage.getItem('dryStatus') == 'true') {
      this.dryStatus = "active";
    }
    if (sessionStorage.getItem('bottleStatus') == 'true') {
      this.bottleStatus = "active";
    }
    if (sessionStorage.getItem('shoesStatus') == 'true') {
      this.shoesStatus = "active";
    }
    if (sessionStorage.getItem('ironStatus') == 'true') {
      this.ironStatus = "active";
    }
    if (sessionStorage.getItem('mesStatus') == 'true') {
      this.mesStatus = "active";
    }
    if (sessionStorage.getItem('chodanStatus') == 'true') {
      this.chodanStatus = "active";
    }
    if (sessionStorage.getItem('petStatus') == 'true') {
      this.petStatus = "active";
    }
    if (sessionStorage.getItem('basketStatus') == 'true') {
      this.basketStatus = "active";
    }
    if (sessionStorage.getItem('lakStatus') == 'true') {
      this.lakStatus = "active";
    }
    if (sessionStorage.getItem('alSabokStatus') == 'true') {
      this.alSabokStatus = "active";
    }
    if (sessionStorage.getItem('alSanginStatus') == 'true') {
      this.alSanginStatus = "active";
    }


    this.cpuCounter = +sessionStorage.getItem('helpCpuCounter')!;
    this.cpuMaxPrice = +sessionStorage.getItem('cpuMaxPrice')!;

    this.riceCounter = +sessionStorage.getItem('helpRiceCounter')!;
    this.riceMaxPrice = +sessionStorage.getItem('riceMaxPrice')!;

    this.plasticCounter = +sessionStorage.getItem('helpPlasticCounter')!;
    this.plasticMaxPrice = +sessionStorage.getItem('plasticMaxPrice')!;

    this.canCounter = +sessionStorage.getItem('helpCanCounter')!;
    this.canMaxPrice = +sessionStorage.getItem('canMaxPrice')!;

    this.bottleCounter = +sessionStorage.getItem('helpBottleCounter')!;
    this.bottleMaxPrice = +sessionStorage.getItem('bottleMaxPrice')!;

    this.paperCounter = +sessionStorage.getItem('helpPaperCounter')!;
    this.paperMaxPrice = +sessionStorage.getItem('paperMaxPrice')!;

    this.shoesCounter = +sessionStorage.getItem('helpShoesCounter')!;
    this.shoesMaxPrice = +sessionStorage.getItem('shoesMaxPrice')!;

    this.dryCounter = +sessionStorage.getItem('helpDryCounter')!;
    this.dryMaxPrice = +sessionStorage.getItem('dryMaxPrice')!;

    this.breadCounter = +sessionStorage.getItem('helpBreadCounter')!;
    this.breadMaxPrice = +sessionStorage.getItem('breadMaxPrice')!;

    this.ironCounter = +sessionStorage.getItem('helpIronCounter')!;
    this.ironMaxPrice = +sessionStorage.getItem('ironMaxPrice')!;

    this.mesCounter = +sessionStorage.getItem('helpMesCounter')!;
    this.mesMaxPrice = +sessionStorage.getItem('mesMaxPrice')!;

    this.chodanCounter = +sessionStorage.getItem('helpChodanCounter')!;
    this.chodanMaxPrice = +sessionStorage.getItem('chodanMaxPrice')!;

    this.petCounter = +sessionStorage.getItem('helpPetCounter')!;
    this.petMaxPrice = +sessionStorage.getItem('petMaxPrice')!;

    this.basketCounter = +sessionStorage.getItem('helpBasketCounter')!;
    this.basketMaxPrice = +sessionStorage.getItem('basketMaxPrice')!;

    this.lakCounter = +sessionStorage.getItem('helpLakCounter')!;
    this.lakMaxPrice = +sessionStorage.getItem('lakMaxPrice')!;

    this.alSabokCounter = +sessionStorage.getItem('helpAlSabokCounter')!;
    this.alSabokMaxPrice = +sessionStorage.getItem('alSabokMaxPrice')!;

    this.alSanginCounter = +sessionStorage.getItem('helpAlSanginCounter')!;
    this.alSanginMaxPrice = +sessionStorage.getItem('alSanginMaxPrice')!;

  }

  ngOnInit() {

  }

  cpuIncrease() {
    this.cpuCounter = this.cpuCounter + 1;
    this.cpuMaxPrice = 35000 * this.cpuCounter;
    sessionStorage.setItem('helpCpuCounter', JSON.stringify(this.cpuCounter));
    sessionStorage.setItem('cpuMaxPrice', JSON.stringify(this.cpuMaxPrice));
  }
  cpuDecrease() {
    if (this.cpuCounter > 0) {
      this.cpuCounter = this.cpuCounter - 1;
      this.cpuMaxPrice = 35000 * this.cpuCounter;
    }
    if (this.cpuCounter == 0) {
      sessionStorage.setItem('cpuStatus', 'false');
      this.cpuMaxPrice = 35000 * this.cpuCounter;
    }
    sessionStorage.setItem('helpCpuCounter', JSON.stringify(this.cpuCounter));
    sessionStorage.setItem('cpuMaxPrice', JSON.stringify(this.cpuMaxPrice));
  }

  riceIncrease() {
    this.riceCounter = this.riceCounter + 1;
    this.riceMaxPrice = 70000 * this.riceCounter;
    sessionStorage.setItem('helpRiceCounter', JSON.stringify(this.riceCounter));
    sessionStorage.setItem('riceMaxPrice', JSON.stringify(this.riceMaxPrice));
  }
  riceDecrease() {
    if (this.riceCounter > 0) {
      this.riceCounter = this.riceCounter - 1;
      this.riceMaxPrice = 70000 * this.riceCounter;
    }
    if (this.riceCounter == 0) {
      sessionStorage.setItem('riceStatus', 'false');
      this.riceMaxPrice = 70000 * this.riceCounter;
    }
    sessionStorage.setItem('helpRiceCounter', JSON.stringify(this.riceCounter));
    sessionStorage.setItem('riceMaxPrice', JSON.stringify(this.riceMaxPrice));
  }

  plasticIncrease() {
    this.plasticCounter = this.plasticCounter + 1;
    this.plasticMaxPrice = 3000 * this.plasticCounter;
    sessionStorage.setItem('helpPlasticCounter', JSON.stringify(this.plasticCounter));
    sessionStorage.setItem('plasticMaxPrice', JSON.stringify(this.plasticMaxPrice));
  }
  plasticDecrease() {
    if (this.plasticCounter > 0) {
      this.plasticCounter = this.plasticCounter - 1;
      this.plasticMaxPrice = 3000 * this.plasticCounter;
    }
    if (this.plasticCounter == 0) {
      sessionStorage.setItem('plasticStatus', 'false');
      this.plasticMaxPrice = 3000 * this.plasticCounter;
    }
    sessionStorage.setItem('helpPlasticCounter', JSON.stringify(this.plasticCounter));
    sessionStorage.setItem('plasticMaxPrice', JSON.stringify(this.plasticMaxPrice));
  }

  canIncrease() {
    this.canCounter = this.canCounter + 1;
    this.canMaxPrice = 3800 * this.canCounter;
    sessionStorage.setItem('helpCanCounter', JSON.stringify(this.canCounter));
    sessionStorage.setItem('canMaxPrice', JSON.stringify(this.canMaxPrice));
  }
  canDecrease() {
    if (this.canCounter > 0) {
      this.canCounter = this.canCounter - 1;
      this.canMaxPrice = 3800 * this.canCounter;
    }
    if (this.canCounter == 0) {
      sessionStorage.setItem('canStatus', 'false');
      this.canMaxPrice = 3800 * this.canCounter;
    }
    sessionStorage.setItem('helpCanCounter', JSON.stringify(this.canCounter));
    sessionStorage.setItem('canMaxPrice', JSON.stringify(this.canMaxPrice));
  }

  bottleIncrease() {
    this.bottleCounter = this.bottleCounter + 1;
    this.bottleMaxPrice = 180 * this.bottleCounter;
    sessionStorage.setItem('helpBottleCounter', JSON.stringify(this.bottleCounter));
    sessionStorage.setItem('bottleMaxPrice', JSON.stringify(this.bottleMaxPrice));
  }
  bottleDecrease() {
    if (this.bottleCounter > 0) {
      this.bottleCounter = this.bottleCounter - 1;
      this.bottleMaxPrice = 180 * this.bottleCounter;
    }
    if (this.bottleCounter == 0) {
      sessionStorage.setItem('bottleStatus', 'false');
      this.bottleMaxPrice = 180 * this.bottleCounter;
    }
    sessionStorage.setItem('helpBottleCounter', JSON.stringify(this.bottleCounter));
    sessionStorage.setItem('bottleMaxPrice', JSON.stringify(this.bottleMaxPrice));
  }

  paperIncrease() {
    this.paperCounter = this.paperCounter + 1;
    this.paperMaxPrice = 1750 * this.paperCounter;
    sessionStorage.setItem('helpPaperCounter', JSON.stringify(this.paperCounter));
    sessionStorage.setItem('paperMaxPrice', JSON.stringify(this.paperMaxPrice));
  }
  paperDecrease() {
    if (this.paperCounter > 0) {
      this.paperCounter = this.paperCounter - 1;
      this.paperMaxPrice = 1750 * this.paperCounter;
    }
    if (this.paperCounter == 0) {
      sessionStorage.setItem('paperStatus', 'false');
      this.paperMaxPrice = 1750 * this.paperCounter;
    }
    sessionStorage.setItem('helpPaperCounter', JSON.stringify(this.paperCounter));
    sessionStorage.setItem('paperMaxPrice', JSON.stringify(this.paperMaxPrice));
  }

  shoesIncrease() {
    this.shoesCounter = this.shoesCounter + 1;
    this.shoesMaxPrice = 12000 * this.shoesCounter;
    sessionStorage.setItem('helpShoesCounter', JSON.stringify(this.shoesCounter));
    sessionStorage.setItem('shoesMaxPrice', JSON.stringify(this.shoesMaxPrice));
  }
  shoesDecrease() {
    if (this.shoesCounter > 0) {
      this.shoesCounter = this.shoesCounter - 1;
      this.shoesMaxPrice = 12000 * this.shoesCounter;
    }
    if (this.shoesCounter == 0) {
      sessionStorage.setItem('shoesStatus', 'false');
      this.shoesMaxPrice = 12000 * this.shoesCounter;
    }
    sessionStorage.setItem('helpShoesCounter', JSON.stringify(this.shoesCounter));
    sessionStorage.setItem('shoesMaxPrice', JSON.stringify(this.shoesMaxPrice));
  }

  dryIncrease() {
    this.dryCounter = this.dryCounter + 1;
    this.dryMaxPrice = 22000 * this.dryCounter;
    sessionStorage.setItem('helpDryCounter', JSON.stringify(this.dryCounter));
    sessionStorage.setItem('dryMaxPrice', JSON.stringify(this.dryMaxPrice));
  }
  dryDecrease() {
    if (this.dryCounter > 0) {
      this.dryCounter = this.dryCounter - 1;
      this.dryMaxPrice = 22000 * this.dryCounter;
    }
    if (this.dryCounter == 0) {
      sessionStorage.setItem('dryStatus', 'false');
      this.dryMaxPrice = 22000 * this.dryCounter;
    }
    sessionStorage.setItem('helpDryCounter', JSON.stringify(this.dryCounter));
    sessionStorage.setItem('dryMaxPrice', JSON.stringify(this.dryMaxPrice));
  }

  breadIncrease() {
    this.breadCounter = this.breadCounter + 1;
    this.breadMaxPrice = 1600 * this.breadCounter;
    sessionStorage.setItem('helpBreadCounter', JSON.stringify(this.breadCounter));
    sessionStorage.setItem('breadMaxPrice', JSON.stringify(this.breadMaxPrice));
  }
  breadDecrease() {
    if (this.breadCounter > 0) {
      this.breadCounter = this.breadCounter - 1;
      this.breadMaxPrice = 1600 * this.breadCounter;
    }
    if (this.breadCounter == 0) {
      sessionStorage.setItem('breadStatus', 'false');
      this.breadMaxPrice = 1600 * this.breadCounter;
    }
    sessionStorage.setItem('helpBreadCounter', JSON.stringify(this.breadCounter));
    sessionStorage.setItem('breadMaxPrice', JSON.stringify(this.breadMaxPrice));
    // console.log(sessionStorage.getItem('helpBreadCounter'));

  }

  ironIncrease() {
    this.ironCounter = this.ironCounter + 1;
    this.ironMaxPrice = 5100 * this.ironCounter;
    sessionStorage.setItem('helpIronCounter', JSON.stringify(this.ironCounter));
    sessionStorage.setItem('ironMaxPrice', JSON.stringify(this.ironMaxPrice));
  }
  ironDecrease() {
    if (this.ironCounter > 0) {
      this.ironCounter = this.ironCounter - 1;
      this.ironMaxPrice = 5100 * this.ironCounter;
    }
    if (this.ironCounter == 0) {
      sessionStorage.setItem('ironStatus', 'false');
      this.ironMaxPrice = 5100 * this.ironCounter;
    }
    sessionStorage.setItem('helpIronCounter', JSON.stringify(this.ironCounter));
    sessionStorage.setItem('ironMaxPrice', JSON.stringify(this.ironMaxPrice));
  }

  mesIncrease() {
    this.mesCounter = this.mesCounter + 1;
    this.mesMaxPrice = 80000 * this.mesCounter;
    sessionStorage.setItem('helpMesCounter', JSON.stringify(this.mesCounter));
    sessionStorage.setItem('mesMaxPrice', JSON.stringify(this.mesMaxPrice));
  }
  mesDecrease() {
    if (this.mesCounter > 0) {
      this.mesCounter = this.mesCounter - 1;
      this.mesMaxPrice = 80000 * this.mesCounter;
    }
    if (this.ironCounter == 0) {
      sessionStorage.setItem('mesStatus', 'false');
      this.mesMaxPrice = 80000 * this.mesCounter;
    }
    sessionStorage.setItem('helpMesCounter', JSON.stringify(this.mesCounter));
    sessionStorage.setItem('mesMaxPrice', JSON.stringify(this.mesMaxPrice));
  }


  chodanIncrease() {
    this.chodanCounter = this.chodanCounter + 1;
    this.chodanMaxPrice = 35000 * this.chodanCounter;
    sessionStorage.setItem('helpChodanCounter', JSON.stringify(this.chodanCounter));
    sessionStorage.setItem('chodanMaxPrice', JSON.stringify(this.chodanMaxPrice));
  }
  chodanDecrease() {
    if (this.chodanCounter > 0) {
      this.chodanCounter = this.chodanCounter - 1;
      this.chodanMaxPrice = 35000 * this.chodanCounter;
    }
    if (this.chodanCounter == 0) {
      sessionStorage.setItem('chodanStatus', 'false');
      this.chodanMaxPrice = 35000 * this.chodanCounter;
    }
    sessionStorage.setItem('helpChodanCounter', JSON.stringify(this.chodanCounter));
    sessionStorage.setItem('chodanMaxPrice', JSON.stringify(this.chodanMaxPrice));
  }

  petIncrease() {
    this.petCounter = this.petCounter + 1;
    this.petMaxPrice = 2500 * this.petCounter;
    sessionStorage.setItem('helpPetCounter', JSON.stringify(this.petCounter));
    sessionStorage.setItem('petMaxPrice', JSON.stringify(this.petMaxPrice));
  }
  petDecrease() {
    if (this.petCounter > 0) {
      this.petCounter = this.petCounter - 1;
      this.petMaxPrice = 2500 * this.petCounter;
    }
    if (this.petCounter == 0) {
      sessionStorage.setItem('petStatus', 'false');
      this.petMaxPrice = 2500 * this.petCounter;
    }
    sessionStorage.setItem('helpPetCounter', JSON.stringify(this.petCounter));
    sessionStorage.setItem('petMaxPrice', JSON.stringify(this.petMaxPrice));
  }

  basketIncrease() {
    this.basketCounter = this.basketCounter + 1;
    this.basketMaxPrice = 3000 * this.basketCounter;
    sessionStorage.setItem('helpBasketCounter', JSON.stringify(this.basketCounter));
    sessionStorage.setItem('basketMaxPrice', JSON.stringify(this.basketMaxPrice));
  }
  basketDecrease() {
    if (this.basketCounter > 0) {
      this.basketCounter = this.basketCounter - 1;
      this.basketMaxPrice = 3000 * this.basketCounter;
    }
    if (this.basketCounter == 0) {
      sessionStorage.setItem('basketStatus', 'false');
      this.basketMaxPrice = 3000 * this.basketCounter;
    }
    sessionStorage.setItem('helpBasketCounter', JSON.stringify(this.basketCounter));
    sessionStorage.setItem('basketMaxPrice', JSON.stringify(this.basketMaxPrice));
  }

  lakIncrease() {
    this.lakCounter = this.lakCounter + 1;
    this.lakMaxPrice = 2500 * this.lakCounter;
    sessionStorage.setItem('helpLakCounter', JSON.stringify(this.lakCounter));
    sessionStorage.setItem('lakMaxPrice', JSON.stringify(this.lakMaxPrice));
  }
  lakDecrease() {
    if (this.lakCounter > 0) {
      this.lakCounter = this.lakCounter - 1;
      this.lakMaxPrice = 2500 * this.lakCounter;
    }
    if (this.lakCounter == 0) {
      sessionStorage.setItem('lakStatus', 'false');
      this.lakMaxPrice = 2500 * this.lakCounter;
    }
    sessionStorage.setItem('helpLakCounter', JSON.stringify(this.lakCounter));
    sessionStorage.setItem('lakMaxPrice', JSON.stringify(this.lakMaxPrice));
  }

  alSabokIncrease() {
    this.alSabokCounter = this.alSabokCounter + 1;
    this.alSabokMaxPrice = 13000 * this.alSabokCounter;
    sessionStorage.setItem('helpAlSabokCounter', JSON.stringify(this.alSabokCounter));
    sessionStorage.setItem('alSabokMaxPrice', JSON.stringify(this.alSabokMaxPrice));
  }
  alSabokDecrease() {
    if (this.alSabokCounter > 0) {
      this.alSabokCounter = this.alSabokCounter - 1;
      this.alSabokMaxPrice = 13000 * this.alSabokCounter;
    }
    if (this.alSabokCounter == 0) {
      sessionStorage.setItem('alSabokStatus', 'false');
      this.alSabokMaxPrice = 13000 * this.alSabokCounter;
    }
    sessionStorage.setItem('helpAlSabokCounter', JSON.stringify(this.alSabokCounter));
    sessionStorage.setItem('alSabokMaxPrice', JSON.stringify(this.alSabokMaxPrice));
  }

  alSanginIncrease() {
    this.alSanginCounter = this.alSanginCounter + 1;
    this.alSanginMaxPrice = 15000 * this.alSanginCounter;
    sessionStorage.setItem('helpAlSanginCounter', JSON.stringify(this.alSanginCounter));
    sessionStorage.setItem('alSabokMaxPrice', JSON.stringify(this.alSanginMaxPrice));
  }
  alSanginDecrease() {
    if (this.alSanginCounter > 0) {
      this.alSanginCounter = this.alSanginCounter - 1;
      this.alSanginMaxPrice = 15000 * this.alSanginCounter;
    }
    if (this.alSanginCounter == 0) {
      sessionStorage.setItem('alSanginStatus', 'false');
      this.alSanginMaxPrice = 15000 * this.alSanginCounter;
    }
    sessionStorage.setItem('helpAlSanginCounter', JSON.stringify(this.alSanginCounter));
    sessionStorage.setItem('alSanginMaxPrice', JSON.stringify(this.alSanginMaxPrice));
  }

  cancelBread() {
    this.displayBread = "displayNone";
    this.breadCounter = 0;
    sessionStorage.setItem('breadStatus', 'false');
    this.breadMaxPrice = 1600 * this.breadCounter;
    sessionStorage.setItem('helpBreadCounter', JSON.stringify(this.breadCounter));
    sessionStorage.setItem('breadMaxPrice', JSON.stringify(this.breadMaxPrice));
  }
  cancelMes() {
    this.displayMes = "displayNone";
    this.mesCounter = 0;
    sessionStorage.setItem('mesStatus', 'false');
    this.mesMaxPrice = 80000 * this.mesCounter;
    sessionStorage.setItem('helpMesCounter', JSON.stringify(this.mesCounter));
    sessionStorage.setItem('mesMaxPrice', JSON.stringify(this.mesMaxPrice));
  }
  cancelDry() {
    this.displayDry = "displayNone";
    this.dryCounter = 0;
    sessionStorage.setItem('dryStatus', 'false');
    this.dryMaxPrice = 22000 * this.dryCounter;
    sessionStorage.setItem('helpDryCounter', JSON.stringify(this.dryCounter));
    sessionStorage.setItem('dryMaxPrice', JSON.stringify(this.dryMaxPrice));
  }
  cancelLak() {
    this.displayLak = "displayNone";
    this.lakCounter = 0;
    sessionStorage.setItem('lakStatus', 'false');
    this.lakMaxPrice = 2500 * this.lakCounter;
    sessionStorage.setItem('helpLakCounter', JSON.stringify(this.lakCounter));
    sessionStorage.setItem('lakMaxPrice', JSON.stringify(this.lakMaxPrice));
  }
  cancelPet() {
    this.displayPet = "displayNone";
    this.petCounter = 0;
    sessionStorage.setItem('petStatus', 'false');
    this.petMaxPrice = 2500 * this.petCounter;
    sessionStorage.setItem('helpPetCounter', JSON.stringify(this.petCounter));
    sessionStorage.setItem('petMaxPrice', JSON.stringify(this.petMaxPrice));
  }
  cancelAlSabok() {
    this.displayAlSabok = "displayNone";
    this.alSabokCounter = 0;
    sessionStorage.setItem('alSabokStatus', 'false');
    this.alSabokMaxPrice = 13000 * this.alSabokCounter;
    sessionStorage.setItem('helpAlSabokCounter', JSON.stringify(this.alSabokCounter));
    sessionStorage.setItem('alSabokMaxPrice', JSON.stringify(this.alSabokMaxPrice));
  }
  cancelAlSangin() {
    this.displayAlSangin = "displayNone";
    this.alSanginCounter = 0;
    sessionStorage.setItem('alSanginStatus', 'false');
    this.alSanginMaxPrice = 15000 * this.alSanginCounter;
    sessionStorage.setItem('helpAlSanginCounter', JSON.stringify(this.alSanginCounter));
    sessionStorage.setItem('alSanginMaxPrice', JSON.stringify(this.alSanginMaxPrice));
  }
  cancelIron() {
    this.displayIron = "displayNone";
    this.ironCounter = 0;
    sessionStorage.setItem('ironStatus', 'false');
    this.ironMaxPrice = 5100 * this.ironCounter;
    sessionStorage.setItem('helpIronCounter', JSON.stringify(this.ironCounter));
    sessionStorage.setItem('ironMaxPrice', JSON.stringify(this.ironMaxPrice));
  }
  cancelCpu() {
    this.displayCpu = "displayNone";
    this.cpuCounter = 0;
    sessionStorage.setItem('cpuStatus', 'false');
    this.cpuMaxPrice = 35000 * this.cpuCounter;
    sessionStorage.setItem('helpCpuCounter', JSON.stringify(this.cpuCounter));
    sessionStorage.setItem('cpuMaxPrice', JSON.stringify(this.cpuMaxPrice));
  }
  cancelRice() {
    this.displayRice = "displayNone";
    this.riceCounter = 0;
    sessionStorage.setItem('riceStatus', 'false');
    this.riceMaxPrice = 70000 * this.riceCounter;
    sessionStorage.setItem('helpRiceCounter', JSON.stringify(this.riceCounter));
    sessionStorage.setItem('riceMaxPrice', JSON.stringify(this.riceMaxPrice));
  }
  cancelPlastic() {
    this.displayPlastic = "displayNone";
    this.plasticCounter = 0;
    sessionStorage.setItem('plasticStatus', 'false');
    this.plasticMaxPrice = 3000 * this.plasticCounter;
    sessionStorage.setItem('helpPlasticCounter', JSON.stringify(this.plasticCounter));
    sessionStorage.setItem('plasticMaxPrice', JSON.stringify(this.plasticMaxPrice));
  }
  cancelChodan() {
    this.displayChodan = "displayNone";
    this.chodanCounter = 0;
    sessionStorage.setItem('chodanStatus', 'false');
    this.chodanMaxPrice = 35000 * this.chodanCounter;
    sessionStorage.setItem('helpChodanCounter', JSON.stringify(this.chodanCounter));
    sessionStorage.setItem('chodanMaxPrice', JSON.stringify(this.chodanMaxPrice));
  }
  cancelCan() {
    this.displayCan = "displayNone";
    this.canCounter = 0;
    sessionStorage.setItem('canStatus', 'false');
    this.canMaxPrice = 3800 * this.canCounter;
    sessionStorage.setItem('helpCanCounter', JSON.stringify(this.canCounter));
    sessionStorage.setItem('canMaxPrice', JSON.stringify(this.canMaxPrice));
  }
  cancelBasket() {
    this.displayBasket = "displayNone";
    this.basketCounter = 0;
    sessionStorage.setItem('basketStatus', 'false');
    this.basketMaxPrice = 3000 * this.basketCounter;
    sessionStorage.setItem('helpBasketCounter', JSON.stringify(this.basketCounter));
    sessionStorage.setItem('basketMaxPrice', JSON.stringify(this.basketMaxPrice));

  }
  cancelBottle() {
    this.displayBottle = "displayNone";
    this.bottleCounter = 0;
    sessionStorage.setItem('bottleStatus', 'false');
    this.bottleMaxPrice = 180 * this.bottleCounter;
    sessionStorage.setItem('helpBottleCounter', JSON.stringify(this.bottleCounter));
    sessionStorage.setItem('bottleMaxPrice', JSON.stringify(this.bottleMaxPrice));
  }
  cancelShoes() {
    this.displayShoes = "displayNone";
    this.shoesCounter = 0;
    sessionStorage.setItem('shoesStatus', 'false');
    this.shoesMaxPrice = 12000 * this.shoesCounter;
    sessionStorage.setItem('helpShoesCounter', JSON.stringify(this.shoesCounter));
    sessionStorage.setItem('shoesMaxPrice', JSON.stringify(this.shoesMaxPrice));
  }
  cancelPaper() {
    this.displayPaper = "displayNone";
    this.paperCounter = 0;
    sessionStorage.setItem('paperStatus', 'false');
    this.paperMaxPrice = 1750 * this.paperCounter;
    sessionStorage.setItem('helpPaperCounter', JSON.stringify(this.paperCounter));
    sessionStorage.setItem('paperMaxPrice', JSON.stringify(this.paperMaxPrice));
  }



  addwaste() {
    this.router.navigate(['waste-list']);
  }

  doneclick() {
    this.loading = true;
    this.money = this.cpuMaxPrice + this.riceMaxPrice + this.plasticMaxPrice + this.shoesMaxPrice +
      this.breadMaxPrice + this.dryMaxPrice + this.paperMaxPrice + this.bottleMaxPrice + this.canMaxPrice +
      this.ironMaxPrice + this.mesMaxPrice + this.chodanMaxPrice + this.petMaxPrice + this.basketMaxPrice +
      this.lakMaxPrice + this.alSabokMaxPrice + this.alSanginMaxPrice;

    if (this.money != 0) {
      this.publicservice.makeOrder(this.money, this.cpuCounter, this.riceCounter, this.plasticCounter,
        this.breadCounter, this.paperCounter, this.canCounter, this.bottleCounter, this.dryCounter, this.shoesCounter,
        this.ironCounter, this.mesCounter, this.chodanCounter, this.petCounter, this.basketCounter, this.lakCounter, this.alSabokCounter, this.alSanginCounter).then((r) => {

          this.loading = true;

          this.router.navigate(['done']);
          sessionStorage.setItem('plasticStatus', 'false');
          sessionStorage.setItem('breadStatus', 'false');
          sessionStorage.setItem('cpuStatus', 'false');
          sessionStorage.setItem('paperStatus', 'false');
          sessionStorage.setItem('canStatus', 'false');
          sessionStorage.setItem('riceStatus', 'false');
          sessionStorage.setItem('dryStatus', 'false');
          sessionStorage.setItem('bottleStatus', 'false');
          sessionStorage.setItem('shoesStatus', 'false');
          sessionStorage.setItem('ironStatus', 'false');
          sessionStorage.setItem('mesStatus', 'false');
          sessionStorage.setItem('chodanStatus', 'false');
          sessionStorage.setItem('petStatus', 'false');
          sessionStorage.setItem('basketStatus', 'false');
          sessionStorage.setItem('lakStatus', 'false');
          sessionStorage.setItem('alSabokStatus', 'false');
          sessionStorage.setItem('alSanginStatus', 'false');

          sessionStorage.setItem('helpCpuCounter', '0');
          sessionStorage.setItem('helpPlasticCounter', '0');
          sessionStorage.setItem('helpBreadCounter', '0');
          sessionStorage.setItem('helpPaperCounter', '0');
          sessionStorage.setItem('helpCanCounter', '0');
          sessionStorage.setItem('helpRiceCounter', '0');
          sessionStorage.setItem('helpDryCounter', '0');
          sessionStorage.setItem('helpBottleCounter', '0');
          sessionStorage.setItem('helpShoesCounter', '0');
          sessionStorage.setItem('helpIronCounter', '0');
          sessionStorage.setItem('helpMesCounter', '0');
          sessionStorage.setItem('helpChodanCounter', '0');
          sessionStorage.setItem('helpPetCounter', '0');
          sessionStorage.setItem('helpBasketCounter', '0');
          sessionStorage.setItem('helpLakCounter', '0');
          sessionStorage.setItem('helpAlSabokCounter', '0');
          sessionStorage.setItem('helpAlSanginCounter', '0');

          sessionStorage.setItem('plasticMaxPrice', '0');
          sessionStorage.setItem('cpuMaxPrice', '0');
          sessionStorage.setItem('paperMaxPrice', '0');
          sessionStorage.setItem('canMaxPrice', '0');
          sessionStorage.setItem('riceMaxPrice', '0');
          sessionStorage.setItem('dryMaxPrice', '0');
          sessionStorage.setItem('bottleMaxPrice', '0');
          sessionStorage.setItem('shoesMaxPrice', '0');
          sessionStorage.setItem('breadMaxPrice', '0');
          sessionStorage.setItem('ironMaxPrice', '0');
          sessionStorage.setItem('mesMaxPrice', '0');
          sessionStorage.setItem('chodanMaxPrice', '0');
          sessionStorage.setItem('petMaxPrice', '0');
          sessionStorage.setItem('basketMaxPrice', '0');
          sessionStorage.setItem('lakMaxPrice', '0');
          sessionStorage.setItem('alSabokMaxPrice', '0');
          sessionStorage.setItem('alSanginMaxPrice', '0');

        })
    } else {
      alert("هیچ پسماندی انتخاب نشده!")
    }


  }

  setname() {
    var ProductName = sessionStorage.getItem('ProductName');
    return ProductName;
  }



}
